import { render, staticRenderFns } from "./r-item-cluster-page.vue?vue&type=template&id=733798a6"
import script from "./r-item-cluster-page.vue?vue&type=script&lang=js"
export * from "./r-item-cluster-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('733798a6')) {
      api.createRecord('733798a6', component.options)
    } else {
      api.reload('733798a6', component.options)
    }
    module.hot.accept("./r-item-cluster-page.vue?vue&type=template&id=733798a6", function () {
      api.rerender('733798a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-cluster/r-item-cluster-page.vue"
export default component.exports